<ejs-dialog
	#modal
	(close)="closeModal()"
	cssClass="modal-md"
	[attr.data-test-id]="'sendFeedbackModal'">
	<ng-template #header>
		<div class="dlg-template">Send Feedback</div>
	</ng-template>
	<ng-template #content>
		<form [formGroup]="formGroup" #templateForm="ngForm" (ngSubmit)="submit()">
			<div class="alert alert-warning">
				In an effort to ensure patient privacy, please do not include any protected health information (PHI) in your message.
			</div>
			@if (formGroup.invalid && templateForm.submitted) {
				<gandalf-lib-validation-messages
					[form]="formGroup"
					[requestObj]="request">
				</gandalf-lib-validation-messages>
			}
			<div class="row mb-3" [attr.data-test-id]="'feedbackFormGroup'">
				<label class="required">Feedback</label>
				<textarea formControlName="feedback" class="e-input" rows="10"></textarea>
			</div>
			<div class="row mb-3" [attr.data-test-id]="'emailAddressFormGroup'">
				<label class="required">Your Email Address</label>
				<input formControlName="emailAddress" class="e-input"/>
			</div>
		</form>
	</ng-template>
	<ng-template #footerTemplate>
		<maj-button icon="times" label="Cancel" (clicked)="closeModal()" dataTestId="sendFeedbackCancelButton"></maj-button>
		<maj-button type="submit" variant="primary" label="Send" (clicked)="submitForm($event)"
					dataTestId="sendFeedbackSendButton"></maj-button>
	</ng-template>
</ejs-dialog>
